export default __webpack_public_path__ + "static/media/section-4-left.3a5f7dee.png";